import {GET_EMAIL_TEMPLATE,GET_EMAIL_DETAILS} from "./actions";

const initialState={
    emailTemplate:{
        docs:[],
        totalDocs:0,
        limit:10,
        page:1,
        totalPages:0,
        paginCounter:0,
        hasPrevPage:false,
        hasNextPage:false,
        prevPage:null,
        nextPage:null,
    },
    emailTemplateData:{},
    loading:true,
};

const emailTemplateReducer=(state=initialState,{type,payload})=>{
    switch(type){
        case GET_EMAIL_TEMPLATE:
            return {
                ...state,
                loading:false,
                emailTemplate:payload,
            };
        case GET_EMAIL_DETAILS:
            return {
                ...state,
                loading:false,
                emailTemplateData:payload,
            }
        default:
            return state;
    }
}

export default emailTemplateReducer;